export default __webpack_public_path__ + "static/media/dan.0ee426a4.jpg";